export function createViewRequestId(crypto) {
  const bytes = new Uint8Array(16);
  if (crypto && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(bytes, byte => ('0' + byte.toString(16)).slice(-2)).join('');
}

export function recordViewWithRetry(send, payload, retriesLeft) {
  return Promise.resolve().then(() => send(payload)).then(response => {
    if (response && response.res && response.res.code === 10000) return true;
    if (retriesLeft > 0) return recordViewWithRetry(send, payload, retriesLeft - 1);
    return false;
  }).catch(() => {
    if (retriesLeft > 0) return recordViewWithRetry(send, payload, retriesLeft - 1);
    return false;
  });
}
